import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { QuibblService } from '../../quibbl.service';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'quibbl-card',
  templateUrl: './quibbl-card.component.html',
  styleUrls: ['./quibbl-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuibblCardComponent implements OnInit {

  @Input() quibbl: any;
  @Input() demo: boolean = false;

  public maxOdds = 0;
  public crowdThinks;
  public links;

  public selectedIndex = -1;
  public voteSubscription;

  public now = Date.now();

  constructor(private _qb: QuibblService,
              private auth: AuthService) { }

  ngOnInit() {
    this.updateVoteSubscription();
    for(let option of this.quibbl.options) {
      if(option.odds > this.maxOdds && option.odds > 0.5) {
        this.maxOdds = option.odds;
        this.crowdThinks = option.name;
      }
    }
  }

  ngOnChanges() {
    this.updateVoteSubscription();

    this.links = null;
    if(this.quibbl.links) {
      this.links = [];
      let i = 0;
      for(let link of this.quibbl.links) {
        if(link) {
          let identifiers = link.split('.');
          let identifier = (identifiers.length == 2) ? identifiers[0] : identifiers[1];
          if(identifier) {
            let splitCheck = identifier.split('/');
            identifier = splitCheck[splitCheck.length-1];
            this.links[i] = {
              brand: identifier,
              link: link
            };
            i++;
          }
        }
      }
    }
    //console.log(this.links);
  }

  ngOnDestroy() {
    if(this.voteSubscription) this.voteSubscription.unsubscribe();
  }

  updateVoteSubscription() {
    if(this.demo) {
      return;
    }

    if(this.voteSubscription) this.voteSubscription.unsubscribe();
    this.voteSubscription = this._qb.getCurrentVoteForUser(this.quibbl.$key, this.auth.userIdentifier).subscribe(vote => {
      this.selectedIndex = vote.vote;
    });
  }

  public selectIndex(index: number, identifier: string, category: string) {
    if(this.demo) {
      return;
    }

    this._qb.voteOnQuibbl(identifier, index);
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/quibbl-card/quibbl-card.component.ts